/**
 * @generated SignedSource<<59ecf2457f4667900697a88b9a7387ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LoginMethod = "apple" | "email" | "google" | "guest" | "%future added value";
export type PreLoginQuery$variables = {
  deviceId: string;
  newsletterId?: string | null;
};
export type PreLoginQuery$data = {
  readonly preLogin: {
    readonly email: string | null;
    readonly prefillEmail: string | null;
    readonly prefillType: string | null;
    readonly token: string | null;
    readonly users: ReadonlyArray<{
      readonly email: string;
      readonly flamesCount: number;
      readonly lastLoginAt: number | null;
      readonly loginMethod: LoginMethod | null;
      readonly subscription: boolean | null;
    }> | null;
  } | null;
};
export type PreLoginQuery = {
  response: PreLoginQuery$data;
  variables: PreLoginQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newsletterId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "deviceId",
        "variableName": "deviceId"
      },
      {
        "kind": "Variable",
        "name": "newsletterId",
        "variableName": "newsletterId"
      }
    ],
    "concreteType": "PreLoginReturnType",
    "kind": "LinkedField",
    "name": "preLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "prefillType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "prefillEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "deviceUsers",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flamesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "loginMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoginAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscription",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PreLoginQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PreLoginQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "67c7493c017d703f4b4d6a047a13c5c4",
    "id": null,
    "metadata": {},
    "name": "PreLoginQuery",
    "operationKind": "query",
    "text": "query PreLoginQuery(\n  $deviceId: String!\n  $newsletterId: String\n) {\n  preLogin(deviceId: $deviceId, newsletterId: $newsletterId) {\n    token\n    email\n    prefillType\n    prefillEmail\n    users {\n      email\n      flamesCount\n      loginMethod\n      lastLoginAt\n      subscription\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8393f544839ccb0541bdbeb455db02c7";

export default node;
